"use strict";

import angular from "angular";
import "./loading-dialog.scss";
import { Company } from "../../../../../../gateway/Company/Company";
import { Serie } from "../../../../../../gateway/Serie/Serie";
import * as DateUtils from "../../../../../../utils/date/date";
import { HomeRedirectService } from "../../../../../../presentation/services/HomeRedirectService";
import { RedirectV2Service } from "../../../../../../presentation/services/RedirectV2Service";

export class LoadingDialogController {
    Serie = new Serie();
    Company = new Company();
    constructor(
        locals,
        $mdDialog,
        DSNDialogService,
        $state,
        ParameterizationProcessService,
        CompanyDataService,
        $interval,
        $rootScope
    ) {
        this.locals = locals;
        this.$mdDialog = $mdDialog;
        this.DSNDialogService = DSNDialogService;
        this.$state = $state;
        this.ParameterizationProcessService = ParameterizationProcessService;
        this.CompanyDataService = CompanyDataService;
        this.$interval = $interval;
        this.$rootScope = $rootScope;
        this.locals.title = "Por favor aguarde...";
        this.locals.width = "524px";
        this.loadingsGifs = [
            "assets/images/bolinhas.gif",
            "assets/images/colunas.gif",
            "assets/images/breathing.gif"
        ];
        this.loadingPhrases = [
            "Extraindo os dados dos balancetes da empresa...",
            "Parametrizando as contas da empresa ao Plano Nucont...",
            "Criando o dashboard personalizado da empresa..."
        ];
        this.loadingGifIndex = 0;
        this.loadingPhraseIndex = 0;
        this.loadingPercent = 0;
        this.company = this.CompanyDataService.get();

        // Intervalos para controle
        this.gifInterval = null;
        this.phraseInterval = null;
        this.progressInterval = null;
        this.isProcessComplete = false;
    }

    $onInit() {
        this.start();
        this.$rootScope.$on("CLOSE_PARAMETERIZATION_DIALOG", (event, data) => {
            this.onReceiveEvents();
        });
    }

    $onDestroy() {
        // Limpar intervalos quando o controller for destruído
        this.stopLoadingAnimations();
    }

    async start() {
        if (!this.company) return;
        if (this.ParameterizationProcessService.getStatus() === "PROCESSING") {
            const lastUpdate = this.company.props.autoAssociated?.lastUpdate;
            const currentDate = new Date();
            const { minutes } = DateUtils.elapsed(lastUpdate, currentDate);
            // Reabertura do loading
            this.startLoadingAnimations(minutes);
            // Fazer request na empresa de 1 em 1 minuto para verificar se o processo foi concluido
            return;
        }

        // Iniciar animações do zero (primeiro acesso)
        this.startLoadingAnimations();
    }

    startLoadingAnimations(elapsedMinutes = 0) {
        // Definir estado inicial baseado no tempo decorrido (reabertura)
        if (elapsedMinutes < 2) {
            this.loadingPhraseIndex = 0;
            this.loadingPercent = 20;
        } else if (elapsedMinutes >= 2 && elapsedMinutes < 4) {
            this.loadingPhraseIndex = 1;
            this.loadingPercent = 50;
        } else if (elapsedMinutes >= 4) {
            this.loadingPhraseIndex = 2;
            this.loadingPercent = 75;
        }

        // Alternar GIFs a cada 20 segundos em loop infinito
        this.gifInterval = this.$interval(() => {
            this.loadingGifIndex =
                (this.loadingGifIndex + 1) % this.loadingsGifs.length;
        }, 20000);

        // Alternar frases a cada 30 segundos, parando na última
        this.phraseInterval = this.$interval(() => {
            if (this.loadingPhraseIndex < this.loadingPhrases.length - 1) {
                this.loadingPhraseIndex++;
            } else {
                // Parar o intervalo quando chegar na última frase
                this.$interval.cancel(this.phraseInterval);
                this.phraseInterval = null;
            }
        }, 30000);

        // Incrementar porcentagem a cada 5 segundos (3% a 7% aleatório)
        this.progressInterval = this.$interval(() => {
            if (this.loadingPercent < 92 && !this.isProcessComplete) {
                const increment = Math.floor(Math.random() * 6) + 4; // 4 a 6
                this.loadingPercent = Math.min(
                    this.loadingPercent + increment,
                    95
                );
            } else {
                // Parar no 92%
                this.$interval.cancel(this.progressInterval);
                this.progressInterval = null;
            }
        }, 5000);
    }

    stopLoadingAnimations() {
        // Parar todos os intervalos
        if (this.gifInterval) {
            this.$interval.cancel(this.gifInterval);
            this.gifInterval = null;
        }
        if (this.phraseInterval) {
            this.$interval.cancel(this.phraseInterval);
            this.phraseInterval = null;
        }
        if (this.progressInterval) {
            this.$interval.cancel(this.progressInterval);
            this.progressInterval = null;
        }
    }

    completeLoading() {
        // Método para ser chamado quando o processo terminar
        this.isProcessComplete = true;
        this.loadingPercent = 100;
        this.stopLoadingAnimations();
    }

    onReceiveEvents() {
        this.completeLoading();
        setTimeout(() => {
            this.$mdDialog.hide();
        }, 2000);
    }

    /** Rótulo do link: "Central Consultiva" ou "Carteira", conforme o acesso. */
    get homeLabel() {
        return HomeRedirectService.getLabel();
    }

    goToPortfolio() {
        HomeRedirectService.go({
            accountingId: this.$state.params.accountingId
        });
    }
}

LoadingDialogController.$inject = [
    "locals",
    "$mdDialog",
    "DSNDialogService",
    "$state",
    "ParameterizationProcessService",
    "CompanyDataService",
    "$interval",
    "$rootScope"
];

angular
    .module("nucont.accounting.company.dashboards")
    .controller("LoadingDialogCtrl", LoadingDialogController);
